<template>
  <v-container fluid class="py-0" :style="'height:' + computedPageHeight + 'px'">

    <v-row>
      <v-col
        class="pa-0">

        <!-- on image bar -->
        <v-row class="carousel-top-element white--text">
          <v-col class="py-0 max-width-1200 mx-auto">
            <app-bar-menu
              component="ItSolution"
              logo="light"
              dark="dark">
            </app-bar-menu>
          </v-col>
        </v-row>

        <!-- hero -->
        <v-card flat dark>
          <v-img
            id="img-main"
            src="@/assets/img/it_01.jpg"
            class="grey lighten-2"
            cover
            :max-height="computedPageHeight"
            :style="'height:' + computedPageHeight + 'px'">
            <v-row
              class="fill-height overlay mx-0"
              align="center"
              justify="center">
              <v-col class="">
                <v-row class="mx-0">
                  <!-- <v-col class="text-center display-4 font-weight-medium">
                    {{ $t('rubin.rubin') }} {{ $t('service.itSolutions.title') }}
                  </v-col> -->
                  <v-col class="text-center">
                    <span class="mr-4 subsite-title-1" style="line-height:6rem;">{{ $t('rubin.rubin') }}</span>
                    <span class="subsite-title-2" style="line-height:3rem;">{{ $t('service.itSolutions.title') }}</span>
                  </v-col>
                </v-row>
                <v-row class="mx-0">
                  <v-col class="text-center pa-0 subsite-title-3">
                    {{ $t("service.itSolutions.subtitle") }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <!-- ic img -->
            <v-row class="carousel-bottom-controls">
              <v-col class="pa-0 img-ic-box flip-x">
              </v-col>
            </v-row>

            <!-- landing scroll menu -->
            <v-row class="menu landing-scroll">
              <v-col class="max-width-1200 px-0 mx-auto">
                <v-btn
                  v-for="(item,index) in sections"
                  :key="index"
                  text
                  @click="scrollTOSection(item.id)">
                    {{ $t(item.title) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-img>
        </v-card>

        <v-row class="mx-1">
          <v-col id="company">
            <Service></Service>
          </v-col>
        </v-row>

        <v-row class="mx-0 bg-grey-light">
          <v-col id="development">
            <Development></Development>
          </v-col>
        </v-row>

        <!-- <v-row class="">
          <v-col id="softwareDevelopment">
            <SoftwareDevelopment></SoftwareDevelopment>
          </v-col>
        </v-row>

        <v-row class="">
          <v-col id="modularSoftware">
            <ModularSoftware></ModularSoftware>
          </v-col>
        </v-row> -->

        <v-row class="mx-1">
          <v-col id="reference">
            <Reference></Reference>
          </v-col>
        </v-row>

        <v-row class="mx-0 bg-ruby">
          <v-col>
            <Contact></Contact>
          </v-col>
        </v-row>


      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AppBarMenu from '@/components/Common/AppBar.vue';
  import DataComponentBase from '@/commons/DataComponentBase';

  import Service              from '@/components/ItSolutions/Service.vue'
  import Development          from '@/components/ItSolutions/Development.vue'
  import SoftwareDevelopment  from '@/components/ItSolutions/SoftwareDevelopment.vue'
  import ModularSoftware      from '@/components/ItSolutions/ModularSoftware.vue'
  import Reference            from '@/components/ItSolutions/Reference.vue'
  import Contact              from '@/components/Common/Contact.vue'

  export default {
    name: 'ItSolutions',
    metaInfo: {
      title: 'IT megoldások',
      titleTemplate: '%s - Rubin Informatika',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Informatikai megoldások cégek számára. Megbízható technológia. Kompetencia. Tapasztalat. Egyedi és moduláris szoftverek fejlesztése.'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'energiamenedzsment, energiamérés,  almérés,  infrastruktúrafelügyelet, energiamegtakarítás, teljesítménylekötés, épületfelügyelet, mesterséges intelligencia, integráció'
        }
      ],
      __dangerouslyDisableSanitizers: ['meta'],
    },

    extends: DataComponentBase,

    components: {
      AppBarMenu,
      Service,
      Development,
      SoftwareDevelopment,
      ModularSoftware,
      Reference,
      Contact,
    },

    data: () => ({
      sections: [
        { id: "company",                title: "itSolutions.service.title", },
        { id: "development",            title: "itSolutions.development.title", },
        // { id: "softwareDevelopment",    title: "itSolutions.softwareDevelopment.title", },
        // { id: "modularSoftware",        title: "itSolutions.modularSoftware.title", },
        { id: "reference",              title: "common.references", },
      ],

    }),

    mounted() {
    },

    computed: {
    },

    methods: {
      scrollTOSection(id) {
        var section = document.getElementById(id);
        section.scrollIntoView();
      }
    },

    watch: {
      computedWidth() {
      }
    },
  }

</script>

<style src="../Style.css">
</style>
